var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import './SearchResultItem.scss';
import { decodeEntities } from "@wordpress/html-entities";
var SearchResultItem = /** @class */ (function (_super) {
    __extends(SearchResultItem, _super);
    function SearchResultItem(props) {
        return _super.call(this, props) || this;
    }
    SearchResultItem.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (this.props.resultType == "Tags") {
            var postResult = this.props.result;
            return (React.createElement("li", { className: "searchResultItem" },
                React.createElement("a", { className: "insights__item-tag", href: ((_a = this.props.result) === null || _a === void 0 ? void 0 : _a.link) ? (_b = this.props.result) === null || _b === void 0 ? void 0 : _b.link : (_c = this.props.result) === null || _c === void 0 ? void 0 : _c.link }, decodeEntities(postResult.name))));
        }
        else {
            var postResult = this.props.result;
            return (React.createElement("li", { className: "searchResultItem" },
                React.createElement("a", { className: (_d = this.props.result) === null || _d === void 0 ? void 0 : _d.slug, href: ((_e = this.props.result) === null || _e === void 0 ? void 0 : _e.link) ? (_f = this.props.result) === null || _f === void 0 ? void 0 : _f.link : (_g = this.props.result) === null || _g === void 0 ? void 0 : _g.link },
                    React.createElement("span", null,
                        postResult.title.rendered,
                        " "))));
        }
    };
    return SearchResultItem;
}(React.Component));
export default SearchResultItem;
